import { render, staticRenderFns } from "./rsi-button.vue?vue&type=template&id=08dc407c&"
import script from "./rsi-button.vue?vue&type=script&lang=js&"
export * from "./rsi-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports